import React, {Component} from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";

class AddInfo extends Component {
    constructor() {
        super();
        this.state = {
            title: "",
            des: "",
            img: null,
            token: ""
        }
    }

    componentDidMount() {
        var token = localStorage.getItem("admintoken");
        this.setState({ token: token });
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    onFileChange = (e) => {
        this.setState({ img: e.target.files[0] });
    }

    onSubmitForm = (event) => {
        event.preventDefault();
        var val = this.state;

        var formData = new FormData();
        formData.append("token", val.token);
        formData.append("title", val.title);
        formData.append("des", val.des);
        if (val.img) {
            formData.append("img", val.img);
        }

        Axios.post(ApiUrl.baseurl + "info/add", formData)
            .then(res => {
                if(res.data.success || res.status === 201) {
                    toast.success(res.data.success || "Info added successfully", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(
                        () => this.props.history.push(`/info`),
                        300
                    );
                } else {
                    toast.error(res.data.error || "Something went wrong", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch(error => {
                console.log(error);
                toast.error(error.response?.data?.error || "Server error occurred");
            });
    }

    render() {
        return (
            <Menu title="Add New Info">
                <h3 className="bg-white title-head"> Add Information </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={this.onSubmitForm}>
                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            name="title"
                                            required
                                            value={this.state.title}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter title"
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Description</label>
                                        <textarea
                                            name="des"
                                            required
                                            rows="5"
                                            value={this.state.des}
                                            onChange={this.onChangeInput}
                                            className="form-control shadow-none"
                                            placeholder="Enter description"
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label>Image (Optional)</label>
                                        <input
                                            type="file"
                                            onChange={this.onFileChange}
                                            className="form-control shadow-none"
                                        />
                                    </div>
                                    <div className="col-md-12 mt-4 mb-5">
                                        <button type="submit" className="btn btn-primary shadow-none">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default AddInfo;